import { Box, ButtonNew, ColorOptions, convertHexToRGBA, Icon, SpacerNew, Text } from '@jfs/ui-new'
import React from 'react'
import { isIE } from '../../utils'
import { Modal } from '../Modal'

interface ModalConfirmDeleteProps {
  show: boolean
  close: () => void
  onProceed: () => void
  title?: string
  data?: any
  theme?: any
  isLoading?: boolean
  isCard?: boolean
  isApolo?: boolean
}

export const ModalConfirmDelete = ({
  show,
  close,
  onProceed,
  title,
  theme,
  isLoading,
  data,
  isCard,
  isApolo = false,
}: ModalConfirmDeleteProps) => {
  const getContent = () => {
    return (
      <Box
        flexDirection={'column'}
        minHeight={100}
        //height={Dimensions.get('window').height / 3}
        justifyContent={'center'}
        overflow={'hidden'}
        alignItems={'center'}
        zIndex={99999}>
        <Box width={'100%'} flexDirection={'row'} alignItems="center" justifyContent={'space-between'} p={24}>
          <Text
            fontFamily={!isApolo ? 'jiotype-bold' : 'poppins-semibold'}
            fontSize={12}
            color={theme.bodyTextColor as ColorOptions}>
            {title}
          </Text>
          <Box onPress={close} underlayColor={'TRANSPARENT'}>
            <Icon id={'CLOSE'} size={16} color={theme?.bodyTextColor as ColorOptions} />
          </Box>
        </Box>
        <Box ph={24}>
          <Text
            lineHeight={22}
            color={convertHexToRGBA(theme.bodyTextColor, 40) as ColorOptions}
            fontFamily={!isApolo ? 'jiotype-medium' : 'poppins-medium'}
            fontSize={12}>
            Are you sure you want to delete your {isCard ? 'card ' : 'VPA '}
            <Text
              color={theme.bodyTextColor as ColorOptions}
              fontFamily={isApolo ? 'poppins-semibold' : 'jiotype-bold'}>
              {isCard ? data?.cardNumber?.substr(data?.cardNumber?.length - 6) : data?.title}
            </Text>
            {` ? Once deleted your ${isCard ? 'card' : 'VPA'} won't be available in your preferred payment methods`}
          </Text>
        </Box>
        <SpacerNew size={20} direction="vertical" />
        <Box flexDirection={'column'} width={'100%'} ph={24}>
          <ButtonNew
            title={`No, Keep the ${isCard ? 'card' : 'VPA'} saved`}
            onPress={close}
            type="secondaryFullWidth"
            borderColor={theme.brandColor as ColorOptions}
            color={theme.bodyBgColor as ColorOptions}
            titleColor={theme.brandColor as ColorOptions}
            hoverColor={convertHexToRGBA(theme.brandColor, 12) as ColorOptions}
            underlayColor={convertHexToRGBA(theme.brandColor, 90) as ColorOptions}
            height={45}
            width={'100%'}
          />
          <SpacerNew size={20} direction="vertical" />
          <ButtonNew
            title={`Yes, Delete the ${isCard ? 'card' : 'VPA'}`}
            onPress={onProceed}
            type="primaryFullWidth"
            color={theme.brandColor as ColorOptions}
            hoverColor={convertHexToRGBA(theme.brandColor, 80) as ColorOptions}
            titleColor={theme.bodyBgColor as ColorOptions}
            underlayColor={convertHexToRGBA(theme.brandColor, 90) as ColorOptions}
            height={45}
            width={'100%'}
            isLoading={isLoading}
          />
          <SpacerNew size={20} direction="vertical" />
        </Box>
      </Box>
    )
  }
  return (
    <>
      <Modal show={show} type={'Bottom'} theme={theme} containerTopPadding={isIE() ? 5 : undefined}>
        {getContent()}
      </Modal>
    </>
  )
}
